<!-- NOTA: MANCA VERSIONE MOBILE -->
<div *ngIf="!disabled" class="tl-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}" [id]="selectId">
    <span *ngIf="labelText != ''" class="tl-label" [ngClass]="{'tl-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <!--  [ngClass]="{'tl-input-error' : !isValid, 'tl-input-mobile' : isMobile}" -->
    <div class="tl-input-cnt" [ngClass]="{'tl-input-error' : !isValid, 'tl-input-mobile' : isMobile}">
        <input type=text class="tl-input" 
        [value]="value" readonly [title]="value">
        <i class="fal fa-ellipsis ico-list" (click)="onClickOpenList()"></i>
    </div>
</div>
<!-- LIST -->
<div class="tl-list-cnt" [id]="optionsListId" style="display: none;">
    <div class="tl-list-row" *ngFor="let opt of optionsList; let i = index" (click)="selectThis($event, opt)" > <!-- [ngClass]="{'tl-row-selected' : imSelected(opt.value!)}" -->
        <span class="tl-list-span" [ngClass]="{'last-opt' : i == (optionsList.length-1), 'tl-span-selected' : imSelected(opt.value!)}">{{opt.text}}</span>
        <i *ngIf="imSelected(opt.value!)" class="fas fa-check green mr-5"></i>
    </div>
</div>

<div *ngIf="disabled" class="tl-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != ''" class="tl-label-disabled">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div class="tl-input-cnt tl-input-cnt-disabled">
        <input type=text class="tl-input tl-input-disabled" [value]="value" readonly [ngClass]="{'tl-input-mobile' : isMobile}">
        <i class="fal fa-ellipsis ico-list-disabled" (click)="onClickOpenList()"></i>
    </div>
</div>

